import { isNotFound, useRouteContext } from '@tanstack/react-router';
import { Skeleton } from '@worldcoo/ui/components/skeleton';
import { Suspense } from 'react';
import { Image } from '../../-components/image';
import { usePortalAuthorQuery } from '@/lib/data-hooks';
import { getLogoImageSize } from '@/lib/shared';
import { usePortalDisplayContext } from './portal-display-context';

export function Logo() {
	const portalData = usePortalDisplayContext();
	if (portalData) {
		return portalData.logoUrl ? (
			<Image
				src={portalData.logoUrl}
				alt={portalData.title ?? ''}
				height={56}
				aspectRatio={2}
				objectFit="contain"
				className="aspect-auto! max-h-14"
			/>
		) : null;
	}
	return <PortalLogo />;
}

function PortalLogo() {
	const { portalId } = useRouteContext({ from: '__root__' });

	return (
		<Suspense fallback={<Skeleton className="bg-secondary" style={{ height: getLogoImageSize(portalId).height }} />}>
			<SuspensedLogo />
		</Suspense>
	);
}

function SuspensedLogo() {
	const { portalId } = useRouteContext({ from: '__root__' });
	const author = usePortalAuthorQuery();

	if (isNotFound(author) || !author.logo) return;

	const logoHeight = getLogoImageSize(portalId).height;
	// Only reserves space against CLS: `aspect-auto!` takes over once the image loads.
	const DEFAULT_LOGO_ASPECT_RATIO = 3;
	const aspectRatio =
		author.logo.width && author.logo.height ? author.logo.width / author.logo.height : DEFAULT_LOGO_ASPECT_RATIO;

	return (
		<Image
			src={author.logo.location}
			alt={author.name ?? ''}
			height={logoHeight}
			aspectRatio={aspectRatio}
			priority
			className="aspect-auto!"
		/>
	);
}
